import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=425be2b7&scoped=true"
import script from "./Performance.vue?vue&type=script&lang=ts"
export * from "./Performance.vue?vue&type=script&lang=ts"
import style0 from "./Performance.vue?vue&type=style&index=0&id=425be2b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425be2b7",
  null
  
)

export default component.exports